/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityByProductWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityByProductWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityByProductWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityByProductWidgetConfiguration>): VulnerabilityByProductWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityByProductWidgetConfiguration(), model);
        VulnerabilityByProductWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityByProductWidgetConfiguration>): VulnerabilityByProductWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityByProductWidgetConfiguration.newInstance(<VulnerabilityByProductWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityByProductWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityByProductWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityByProductWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityByProductWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
